/* import __COLOCATED_TEMPLATE__ from './drawer-content.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import templateOnlyComponent from '@ember/component/template-only';

interface Args {}

const DrawerContent = templateOnlyComponent<Args>();
export default DrawerContent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::HandoffToSalesforceInAppMessaging::DrawerContent': typeof DrawerContent;
    'workflows/graph-editor/node-items/steps/handoff-to-salesforce-in-app-messaging/drawer-content': typeof DrawerContent;
  }
}
